module.exports = __webpack_public_path__ + "static/media/Maple-Crossing-Master-Deed.55ff0e66.pdf";